import { useEffect } from 'react';

export const Accessibility = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-6 py-16" data-testid="accessibility-page">
      <h1 className="font-heading text-4xl mb-8">Accessibility Statement</h1>
      <p className="text-gray-500 text-sm mb-8">Last Updated: March 14, 2026</p>
      
      <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
        <section>
          <h2 className="font-heading text-2xl mb-4">Our Commitment</h2>
          <p>
            Jax Remodeling Solutions LLC is committed to ensuring digital accessibility for people with disabilities. We are continually improving the user experience for everyone and applying the relevant accessibility standards.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">Conformance Status</h2>
          <p>
            We strive to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA standards. These guidelines explain how to make web content more accessible for people with disabilities and more user-friendly for everyone.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">Accessibility Features</h2>
          <p>Our website includes the following accessibility features:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Alternative Text:</strong> Images include descriptive alternative text</li>
            <li><strong>Keyboard Navigation:</strong> All functionality is available via keyboard</li>
            <li><strong>Consistent Navigation:</strong> Navigation is consistent throughout the site</li>
            <li><strong>Readable Text:</strong> Text is resizable and maintains readability</li>
            <li><strong>Color Contrast:</strong> Sufficient color contrast ratios are maintained</li>
            <li><strong>Focus Indicators:</strong> Visible focus indicators for interactive elements</li>
            <li><strong>Form Labels:</strong> All form inputs have associated labels</li>
            <li><strong>Skip Links:</strong> Skip navigation links are provided</li>
            <li><strong>Semantic HTML:</strong> Proper heading hierarchy and semantic markup</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">Assistive Technology Compatibility</h2>
          <p>
            Our website is designed to be compatible with assistive technologies including:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Screen readers (JAWS, NVDA, VoiceOver)</li>
            <li>Screen magnifiers</li>
            <li>Speech recognition software</li>
            <li>Alternative input devices</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">Known Limitations</h2>
          <p>
            While we strive for full accessibility, some content may have limitations:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Third-party content or links may not meet accessibility standards</li>
            <li>Some PDF documents may not be fully accessible</li>
            <li>Interactive features may require JavaScript</li>
          </ul>
          <p className="mt-4">
            We are actively working to address these issues and improve accessibility.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">Physical Accessibility</h2>
          <p>
            In addition to digital accessibility, we are committed to ADA compliance in our remodeling services. We can help design and implement accessible features in your home including:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>ADA-compliant bathroom modifications</li>
            <li>Wheelchair accessible doorways and ramps</li>
            <li>Grab bars and safety features</li>
            <li>Accessible kitchen designs</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">Feedback</h2>
          <p>
            We welcome your feedback on the accessibility of our website. If you encounter accessibility barriers or have suggestions for improvement, please contact us:
          </p>
          <ul className="list-none space-y-2 mt-4">
            <li><strong>Email:</strong> jaxremodelingsolutions@gmail.com</li>
            <li><strong>Phone:</strong> (904) 863-6673</li>
          </ul>
          <p className="mt-4">
            We aim to respond to accessibility feedback within 5 business days.
          </p>
        </section>

        <section>
          <h2 className="font-heading text-2xl mb-4">Enforcement Procedures</h2>
          <p>
            If you are not satisfied with our response, you may file a complaint with the relevant regulatory authority or seek other remedies under applicable law.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Accessibility;
